export const URL_GET_DASHBOARD_REPORT = "/v1/gocheckin/dashboard/site/report";
export const URL_GET_DASHBOARD_CHART_REPORT = "/v1/gocheckin/dashboard/site/report-chart?";
